import styled from 'styled-components';
import { CloudImage } from '@components/CloudImage';
import { themeColor, themeMediaQuery } from '@utils/styledTheme.util';

export const Divider = styled.div`
  height: 10px;
  width: 100%;
  margin-top: 4px;
  border-top: 1px solid ${themeColor('mono4')};
  ${themeMediaQuery('below_sm')} {
    margin-top: 30px;
  }
`;

export const BottomWave = styled(CloudImage)`
  width: 100%;
  position: absolute;
`;
